__turbopack_context__.v({
  "className": "i3RoxG_className",
});
